import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { Button, Card } from "@mui/material";
import FileUploader from "../../FileUploader";
import { endpoints } from "../../../services/apiurl";
import Input from "../../UI/Input/Input";
import PageTitle from "../../UI/PageTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const Editdeal = () => {
  let history = useHistory();
  let { id } = useParams();

  const [cat, setCat] = useState({
    name: "",
    status: "",
    image: "",
    iconName: "",
    restro_id: "",
    path_id: "",
    path_url: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setloading] = useState(false);
  const [rest, setRest] = useState([]);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const { name, status, image, iconName, path_id, path_url, restro_id } = cat;
  const onInputChange = (e) => {
    const inputValue = e.target.value;
    const inputName = e.target.name;

    if (inputName === "name") {
      // Check for special characters
      const disallowedCharacters = /[#$%^&*0-9!@#$%^&*()+=\[\]{}:\\|<>\?]+/;
      if (disallowedCharacters.test(inputValue)) {
        alert("Special characters are not allowed in the Name field");
        return;
      }

      // Check if the input consists only of blank spaces
      if (/^\s+$/.test(inputValue)) {
        alert("Input cannot be only blank spaces");
        return;
      }
    }

    // Update the state for all other inputs
    setCat({ ...cat, [inputName]: inputValue });
  };

  useEffect(() => {
    editcategory();
    getRestaurentsDropDown();
  }, []);

  const getRestaurentsDropDown = async () => {
    await axios.post(endpoints.getRestaurentsDropDown).then((response) => {
      setRest(response.data.data);
    });
  };

  const editcategory = async () => {
    await axios
      .post(endpoints.editRestaurentsDeals, { id: id })
      .then((response) => {
        setCat({
          id: response.data.data.id,
          name: response.data.data.name,
          status: response.data.data.status,
          image: response.data.data.image,
          restro_id: response.data.data.restro_id,
          path_id: response.data.data.path_id,
          path_url: response.data.data.path_url,
          iconName: response.data.data.iconName,
        });
        setStartDate(new Date(response.data.data.start_date));
        setEndDate(new Date(response.data.data.end_date));
      });
  };

  const removeImageHandler = async (id) => {
    await axios
      .post(endpoints.deleteImageDealRest, { id })
      .then((response) => {});
    window.location.reload();
  };

  const onSubmit = async (e) => {
    setloading(true);
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", name);
    formData.append(
      "start_date",
      moment(startDate).format("YY-MM-DD HH:mm:ss")
    );
    formData.append("end_date", moment(endDate).format("YY-MM-DD HH:mm:ss"));
    formData.append("restro_id", restro_id);
    formData.append("image", selectedFile);
    formData.append("status", status);
    formData.append("path_id", path_id);
    formData.append("path_url", path_url);
    formData.append("id", id);
    await axios
      .post(endpoints.updateRestaurentsDeals, formData)
      .then((response) => {
        setloading(false);
        history.goBack();
      });
  };

  return (
    <div className="ui main">
      <PageTitle title="Edit Trending" linkurl="" linkTitle="" />
      <Card className="px-3 py-3">
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <div className="col col-6">
              <label>Restaurents </label>
              <select
                name="restro_id"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
                value={restro_id}
              >
                <option value="">Select Restaurents</option>
                {rest.map((e, key) => {
                  return (
                    <option key={key} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <Input
              id="name"
              label="Name"
              type="text"
              name="name"
              place="Name"
              onChange={(e) => onInputChange(e)}
              requiredInput="true"
              value={name}
              class="col col-6"
            />
          </div>

          <div className="row">
            <div className="col col-6">
              <label>Start Date & Time</label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                timeInputLabel="Time:"
                dateFormat="MM/dd/yyyy h:mm aa"
                showTimeInput
                className="form-control"
              />
            </div>

            <div className="col col-6">
              <label>End Date & Time</label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                timeInputLabel="Time:"
                dateFormat="MM/dd/yyyy h:mm aa"
                showTimeInput
                className="form-control"
              />
            </div>
          </div>

          <div className="row">
            <Input
              id="path_id"
              label="Path ID"
              type="text"
              name="path_id"
              place="Path ID"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={path_id}
              class="col col-6"
            />

            <Input
              id="path_url"
              label="Path Url"
              type="text"
              name="path_url"
              place="Path Url"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={path_url}
              class="col col-6"
            />
          </div>

          <div className="row">
            <div className="col col-6">
              <label>Status</label>
              <select
                name="status"
                className="form-control"
                onChange={(e) => onInputChange(e)}
                value={status}
              >
                <option value="">Select Status</option>
                <option value="2">InActive</option>
                <option value="1">Active</option>
              </select>
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <label>Image</label>
              <FileUploader
                onFileSelectSuccess={(file) => setSelectedFile(file)}
                onFileSelectError={({ error }) => alert(error)}
              />

              {iconName ? (
                <div className="mt-3">
                  <img
                    src={image}
                    height="200px"
                    width="200px"
                    className="px-2"
                  />
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={() => removeImageHandler(id)}
                  >
                    Delete
                  </Button>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default Editdeal;
